import { Routes } from '@angular/router';
import { FieldMapComponent } from './field-map.component';

export const FIELD_MAP_ROUTES: Routes = [
    {
        path: 'field-map-main',
        component: FieldMapComponent,
        pathMatch: 'full',
        data: { pageTitle: 'study-editor.field-map.field.plan.title' }
    }
];
